import React, { useEffect, useState } from "react";
import { Clock3, Sparkles } from "lucide-react";
import { api } from "../../../lib/api";
import { card } from "./shared";

const label = (h) => `${h % 12 || 12} ${h < 12 ? "AM" : "PM"}`;
const C = { taps: "#25D366", chats: "#0e8c7f", quotes: "#f59e0b" };

export default function BestTimeCard() {
  const [days, setDays] = useState(30);
  const [d, setD] = useState(null);
  useEffect(() => { api.get(`/admin/best-times?days=${days}`).then(({ data }) => setD(data)).catch(() => {}); }, [days]);
  if (!d) return null;
  const tot = (r) => r.taps + r.chats + r.quotes;
  const max = Math.max(1, ...d.hours.map(tot));
  const empty = d.hours.every((h) => !tot(h));
  return (
    <div className={card} data-testid="best-time-card">
      <div className="flex flex-wrap items-center gap-2">
        <Clock3 size={18} className="text-[#0e8c7f]" />
        <h3 className="text-[16px] font-bold text-[#0f2e2a]">Best time to post</h3>
        <select value={days} onChange={(e) => setDays(Number(e.target.value))} className="ml-auto rounded-lg border border-[#dcebe8] px-2 py-1 text-[13px]" data-testid="best-time-range">
          <option value={7}>Last 7 days</option><option value={30}>Last 30 days</option><option value={90}>Last 90 days</option>
        </select>
      </div>
      {empty ? <p className="mt-3 text-[13.5px] text-[#6b7c79]" data-testid="best-time-empty">Not enough activity yet. As visitors tap WhatsApp, Call, Text or start chats, the busiest hours will show here.</p> : (
        <>
          <div className="mt-3 flex flex-wrap items-center gap-2 text-[14px]" data-testid="best-time-top">
            <Sparkles size={16} className="text-[#f59e0b]" /><span className="font-semibold">Busiest hours (Eastern):</span>
            {d.top_hours.map((h) => <span key={h} className="rounded-full bg-[#0e8c7f] px-3 py-1 text-[13px] font-bold text-white">{label(h)}</span>)}
            {d.best_day && <span className="text-[#5b6d6a]">· Best day: <b>{d.best_day}</b></span>}
          </div>
          <p className="mt-1 text-[12.5px] text-[#6b7c79]">Tip: post about 1 hour before your busiest hour so people see it when they're most active.</p>
          <div className="mt-4 flex h-36 items-end gap-[3px]" data-testid="best-time-chart">
            {d.hours.map((h) => (
              <div key={h.hour} className="group relative flex h-full flex-1 flex-col justify-end" title={`${label(h.hour)}: ${h.taps} taps, ${h.chats} chats, ${h.quotes} quotes`}>
                {["quotes", "chats", "taps"].map((k) => h[k] > 0 && <div key={k} style={{ height: `${(h[k] / max) * 100}%`, background: C[k] }} className="w-full first:rounded-t" />)}
              </div>
            ))}
          </div>
          <div className="mt-1 flex justify-between text-[10.5px] text-[#8a9a97]"><span>12 AM</span><span>6 AM</span><span>12 PM</span><span>6 PM</span><span>11 PM</span></div>
          <div className="mt-3 flex flex-wrap gap-4 text-[12.5px] text-[#3d504d]">
            {Object.entries(C).map(([k, c]) => <span key={k} className="flex items-center gap-1.5"><span className="h-2.5 w-2.5 rounded-sm" style={{ background: c }} />{k === "taps" ? "WhatsApp/Call/Text taps" : k === "chats" ? "New chats" : "Quotes"}</span>)}
          </div>
        </>
      )}
    </div>
  );
}
